<template>
  <GrDemandasFormPesquisa />
  <div>
    <q-table
      class="fit"
      :columns="columns.map(column => ({ ...column, align: 'left' }))"
      row-key="id"
      :rows="rows"
      @row-click="(evt, row) => $router.push(`/gr/${row.numero}`)"
      @request="request"
      v-model:pagination="_pagination"
    >
      <template v-slot:body-cell-acoes="tema">
        <q-td :props="tema">
          <q-btn
            flat
            icon="delete_outline"
            title="Excluir Tema"
            @click.stop="deleteTema(tema.row.numero)"
            v-if="admin"
          />
        </q-td>
      </template>
    </q-table>
    <AppConfirmModal v-model="confirmThemeDeletion" question="Tem certeza de que deseja excluir o Tema?" @ok="excluirTema(idTemaExcluir)" />
  </div>
</template>


<script setup>
import GrDemandasFormPesquisa from "@/components/gr-demandas-form-pesquisa.vue";
import AppConfirmModal from "@/components/app/AppConfirmModal.vue"
import { useGrSituacaoStore } from "@/store/gr-situacao-store";
import { defineProps, defineEmits, ref, computed } from "vue";
import { useUserStore } from "@/store/user-store";
const userStore = useUserStore();
const situacaoStore = useGrSituacaoStore();
situacaoStore.fetch();

const props = defineProps({
  rows: {},
  pagination: {},
  headers: {
    type: Array,
    default: Array.from([
      "pje",
      "tema",
      "situacao",
      "acoes"
    ])
  }
});


const emit = defineEmits(["del", "update:pagination", "request"]);
const request = v => emit("request", v);
const _pagination = computed({
  get: () => props.pagination,
  set: v => emit("update:pagination", v)
});

const admin = computed(() => userStore.admin);
const nomeSituacaoFromId = id =>
  situacaoStore.all.find(situacao => situacao.id == id)?.descricao;

const confirmThemeDeletion = ref(false);
const idTemaExcluir = ref(0);
const deleteTema = id => {
  idTemaExcluir.value = id;
  confirmThemeDeletion.value = true;
};

const excluirTema = id => emit("del", id);
const allcolumns = computed(()=>[
  {
    name: "pje",
    label: "GR",
    field: "numero"
  },
  {
    name: "tema",
    label: "Questão Jurídica",
    field: "descricao",
    style: () => `overflow: hidden;text-overflow: ellipsis; max-width: 40vw; white-space: pre-wrap;`
  },
  {
    name: "situacao",
    label: "Situação",
    field: "idSituacao",
    format: id => `${nomeSituacaoFromId(id)}`
  },
  { name: "questao", label: "Título", field: "titulo" },
  userStore.admin? { name: "acoes", label: "Ações", field: "acoes" } : {}
]);

const columns = computed(() =>
  allcolumns.value.filter(c => props.headers.includes(c.name))
);
</script>
